import './App.css';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Login from './modules/login/login.container';
import Dashboard from './modules/dashboard/dashboard.container';
import CAN from './casl/can';
import { defineRulesForUser } from "./casl/can";
import { Action, Resource } from './casl/constants';
import { connect } from "react-redux";
import { useEffect, useState, useCallback } from 'react';
import { app } from './configuration/gcp-identity-platform-config';
import { getAuth, onAuthStateChanged, getRedirectResult } from "firebase/auth";
import { getMyRights, updateMyRights, updateIsLoggedIn, logoutUser } from './redux/actions/userManagement/myRights.action';
import AuthGuard from "./hoc/guards/AuthGuard";
import ServicesViewer from './modules/newService/viewer/ServicesViewer';
import Navbar from "./modules/header/NavBar";
import Service from './modules/newService/service/service.container';
import GenericInformation from './modules/genericInformation/GenericInformation.container';
import UserManagement from './modules/userManagement/UserManagement';
import ContactUs from './modules/contactUs/contactus.container';
import CustomerDetail from './modules/userManagement/customer/detail/CustomerDetail.container';
import MFA from "./modules/mfa/multifactorEnabler.container";
import { Footer } from './modules/footer/Footer';
import RouteGuard from './hoc/guards/RouteGuard';
import InvalidUser from './modules/invalidUser/InvalidUser';
import InactiveUser from './modules/inactiveUser/InactiveUser';
import { USER_TYPE, MFA_TYPE, getUserManagementPath, getConnectivityPath, getIncidentManagementPath, getInsightPath } from './utils/constants/userConstants';
import ValidateEmail from './modules/emailValidation/validateEmail.container';
//import useAutoLogout from './modules/inactiveTimeout/Timeout';
//import WarningPopup from './modules/inactiveTimeout/WarningPopup';
//import SessionExpire from './modules/inactiveTimeout/sessionExpire';
import { Alert } from './components/alert/alerts';
import { closeAlertPopup } from './redux/actions/Alert/alert.action';
import IncidentManagement from './modules/incidentManagement/incidentManagement';
import IncidentDetail from './modules/incidentManagement/myIncidents/incidentDetail/incidentDetail.container';
import ServiceRequestDetail from './modules/incidentManagement/myServiceRequest/serviceRequestDetail/serviceRequestDetail.container';
import IdleTimer from './IdleTimer/IdleTimer';
import OnboardingDetail from './modules/userManagement/customer/myRequest/onboardingApproval/detail/onboardingDetail.container';
import OnboardingRequestDetail from './modules/userManagement/customer/myRequest/onboardingRequest/detail/onboardingRequestDetail.container';
import AccountAccessRequestDetail from './modules/userManagement/customer/myRequest/accountAccessRequest/detail/accountAccessRequestDetail.container';
import AccountAccessApprovalDetail from './modules/userManagement/customer/myRequest/accountAccessApproval/detail/accountAccessApprovalDetail.container';
import AccessApprovalDetail from './modules/userManagement/customer/accessApprovalDetails/accessApprovalDetail.container';
import FincaInvoices from './modules/finca/list/fincaInvoices.container';
import AlertMessage from './components/loginAlertMessage/AlertMessage';
import {  showAlertPopup,clearAlertPopup } from './redux/actions/AlertErrorMessage/alertErrorMessage.action';
import BroadCastNotification from './modules/notification/broadCastNotification/broadCastNotification.container';
import Home from './modules/home/home.container';
import Broadcast from './modules/broadcast/broadcast';
import { clearErrorPopup, showErrorPopup } from './redux/actions/customErrorPopup/customerrorpopup.action';
import CustomErrorPopup from './components/customErrorPopup/customError';
import ConsentPopup from './modules/consentPopup/ConsentPopup';
import RegulatoryViewer from './modules/regulatory/regulatory.containor';
import PageNotFound from './modules/pageNotFound/PageNotFound';
import CustomerViewerContainer from './modules/userManagement/customer/list/CustomerViewer.container';
import VFUserViewerContainer from './modules/userManagement/vfUser/list/VFUserViewer.container';
import OnboardingRequestListViewer from './modules/userManagement/customer/myRequest/onboardingRequest/list/onboardingRequestList.container';
import OnboardingApprovalListViewer from './modules/userManagement/customer/myRequest/onboardingApproval/list/onboardingApprovalList.container';
import MyIncidentViewerContainer from './modules/incidentManagement/myIncidents/list/myIncidentViewer.container';
import CloseTicketViewer from "./modules/incidentManagement/myServiceRequest/list/myserviceRequestViewer.container";
import LiveServices from './modules/liveServices/liveServices.container';
import NewRequestViewerContainer from './modules/newService/viewer/newRequestViewer/NewRequestViewer.container';
import { DiameterGraphs, SigtranGraphs, WeatherMapsWrapper } from './modules/dashboard/Dashboard';
import AddDemandContainer from './modules/demand/add/addDemand.container';
import DemandDetailContainer from './modules/demand/detail/demandDetail.container';
import DemandViewerContainer from './modules/demand/list/demandViewer.container';
function App(props) {
  const { myRights, myRightsLoading, userStatus, message, isAlertPopupOpen, isUserLoggedIn } = props;

  //const { showWarning,startSession,endSession, continueSession,hideWarningPopup,hideExpirepopup ,expire} = useAutoLogout();

  useEffect(() => {
    const auth = getAuth(app);
    onAuthStateChanged(auth, (user) => {

      // console.log("onAuthStateChanged user", user);

      if (user) {
        user.reload() // to fix reloadUserInfo null issue  - CUP-1209
        props.getRights();
      } else {
        props.updateRights(null);
        props?.logoutUser();
        //endSession();
        props.updateIsLoggedIn(false);
      }
    });

    // Handle redirect and get user details
    const getUserDetails = async () => {
      try {
        const userCred = await getRedirectResult(auth);
        // console.log("userCred", userCred);
      }
      catch (error) {
        console.log("error", error);
      }
    };

    getUserDetails();
  }, []);

  // Define the constant using the some method
  const canAccessUserManagement = [
    CAN(Action.LIST, Resource.CUSTOMERS),
    CAN(Action.LIST, Resource.RIGHTS),
    CAN(Action.LIST, Resource.CUSTOMER_ONBOARDING_REQUEST)
  ].some(condition => condition);

  const handleCloseAlert = () => {
    props.clearAlertPopup();
  };
  const handleCloseErrorPopup = () => {
    props.clearErrorPopup();
  };
  /*useEffect(()=>{
    defineRulesForUser(myRights?.permissions);
  },[myRights]);*/
  let mfaType = null
  if(getAuth(app)?.currentUser?.reloadUserInfo?.customAttributes){
    mfaType = JSON.parse(getAuth(app)?.currentUser?.reloadUserInfo?.customAttributes)?.mfa_config?.mfa_type;
  }
  //console.log("mfaType",mfaType)
  defineRulesForUser(myRights?.permissions);
  const emailVerified = myRights ? getAuth(app).currentUser?.emailVerified : false;
  const isValidMFAUser = getAuth(app).currentUser?.providerData[0]?.providerId === "password" ? true : false
  //const hasMFAEnabled = getAuth(app).currentUser?.reloadUserInfo?.mfaInfo ? true : false;
  const hasMFAEnabled = (mfaType===MFA_TYPE.EMAIL||mfaType===MFA_TYPE.SMS) ? true : false;
  const isActive = !getAuth(app).currentUser?.reloadUserInfo?.disabled ? true : false;
  return (
    <BrowserRouter>
     {props.isCustomAlertOpen && <AlertMessage alertHeader={props.alertMessage.alertHeader.alertHeader} alertMessage={props.alertMessage.alertMessage.alertMessage} onClose={handleCloseAlert} />}
      {/*(((myRights && myRights?.status == "active" && emailVerified && isValidMFAUser && hasMFAEnabled) || (myRights && myRights?.status == "active" && !hasMFAEnabled && !isValidMFAUser && emailVerified)) && isActive)?
        showWarning && (
        <WarningPopup onContinue={continueSession}  onhide={hideWarningPopup}  />
      ) :<></>*/}
      {/*expire && ( <SessionExpire hideExpirepopup={hideExpirepopup} /> )*/}
      <IdleTimer isUserLoggedIn={isUserLoggedIn} />
      <AuthGuard userDetails={myRights} isAppLoading={myRightsLoading} userStatus={userStatus} updateIsLoggedIn={props.updateIsLoggedIn}>
        <div style={{ backgroundColor: "#F4F4F4" }}>
        {props.isCustomErrorOpen && <CustomErrorPopup errorHeader={props.ErrorMessage.errorHeader.errorHeader} errorMessage={props.ErrorMessage.errorMessage.errorMessage} isnote={props.isnote} onClose={handleCloseErrorPopup} />}
          {(((myRights && myRights?.status == "active" && emailVerified && isValidMFAUser && hasMFAEnabled) || (myRights && myRights?.status == "active" && !hasMFAEnabled && !isValidMFAUser && emailVerified)) && isActive) ? <><ConsentPopup/><Navbar /><BroadCastNotification/> </>: <></>}
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/map" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.IPX_POP)}><GenericInformation /></RouteGuard>} />
            <Route path="/dashboard" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.DASHBOARD_WIDGETS)}><Home/></RouteGuard>} />
            {/* <Route path="/insights/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DIAMETER)}><Dashboard /></RouteGuard>} /> */}
            <Route path="/insights" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DIAMETER)}><Dashboard /></RouteGuard>}>
              <Route index element={getInsightPath()?.navigate}/>
              <Route path="ipLinkUtilization/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.WEATHERMAPS)}><WeatherMapsWrapper/></RouteGuard>} />
              <Route path="diameter/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DIAMETER)}><DiameterGraphs /></RouteGuard>} />
              <Route path="sigtran/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.SIGTRAN)}><SigtranGraphs /></RouteGuard>} />
            </Route>
            {/* <Route path="/connectivity/:data?" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.LIVE_SERVICES) || CAN(Action.GET, Resource.DEMANDS)}><ServicesViewer /></RouteGuard>} /> */}
            <Route path="/connectivity" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.LIVE_SERVICES) || CAN(Action.GET, Resource.DEMANDS)}><ServicesViewer /></RouteGuard>}>
              <Route index element={getConnectivityPath()?.navigate}/>
              <Route path="liveServices/:data?" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.LIVE_SERVICES)}><LiveServices /></RouteGuard>} />
              <Route path="demands/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DEMANDS)}><NewRequestViewerContainer /></RouteGuard>} />
              <Route path="demandToCash/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DEMANDS)}><DemandViewerContainer /></RouteGuard>} />
            </Route>
            <Route path="/connectivity/demandDetail/:requestId/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DEMANDS)}><Service /></RouteGuard>} />
            <Route path="/connectivity/demand/:mode/:demandId?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DEMANDS)}><AddDemandContainer /></RouteGuard>} />
            <Route path="/connectivity/demandToCashDetail/:requestId/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.DEMANDS)}><DemandDetailContainer /></RouteGuard>} />
            <Route path="/contact-us" element={<RouteGuard canAccess={CAN(Action.CREATE, Resource.QUERY)}><ContactUs /></RouteGuard>} />
            {/* <Route path="/user-management/:data?" element={myRights?.userType == USER_TYPE.INTERNAL && <RouteGuard canAccess={canAccessUserManagement}><UserManagement /></RouteGuard>} /> */}
              <Route path="/user-management" element={myRights?.userType == USER_TYPE.INTERNAL && <RouteGuard canAccess={canAccessUserManagement}><UserManagement /></RouteGuard>}>
                <Route index element={getUserManagementPath(myRights)?.navigate}/>
                <Route path="customers/:data?" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.CUSTOMERS)}><CustomerViewerContainer /></RouteGuard>} />
                <Route path="onboardingRequests" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.CUSTOMER_ONBOARDING_REQUEST)}><OnboardingRequestListViewer/></RouteGuard>} />
                <Route path="onboardingApprovals" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.CUSTOMER_ONBOARDING_APPROVAL) && myRights?.functionalRoles[0]!=="super_admin_internal"}><OnboardingApprovalListViewer /></RouteGuard>} />
                <Route path="vodafoneUsers/:data?" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.RIGHTS) && myRights?.functionalRoles[0]==="super_admin_internal"}><VFUserViewerContainer /></RouteGuard>} />
              </Route>
            <Route path="/user-management/customerdetail/:requestId/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.CUSTOMERS)}><CustomerDetail customerId={myRights?.customerUserMetaInfo?.uniqueCustomerRefId}/></RouteGuard>} />
            {/* <Route path="/user-management" element={myRights?.userType == USER_TYPE.INTERNAL ? <RouteGuard canAccess={canAccessUserManagement}><UserManagement /></RouteGuard> : <RouteGuard canAccess={CAN(Action.GET, Resource.CUSTOMERS)}><CustomerDetail customerId={myRights?.customerUserMetaInfo?.uniqueCustomerRefId} /></RouteGuard>} />
            <Route path="/user-management/:requestId" element={myRights?.userType == USER_TYPE.INTERNAL &&<RouteGuard canAccess={CAN(Action.GET, Resource.CUSTOMERS)}><CustomerDetail/></RouteGuard>} /> */}
            <Route path='/enable-mfa' element={<MFA />} />
            <Route path="/verifyemail" element={<ValidateEmail />} />
            <Route path="/invalid-user" element={<InvalidUser />} />
            <Route path="/inactive-user" element={<InactiveUser />} />
            {/* <Route path="/incident-management/:data?" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.INCIDENTS) || CAN(Action.LIST, Resource.SERVICE_REQUESTS)}><IncidentManagement /></RouteGuard>} /> */}
            <Route path="/incident-management" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.INCIDENTS) || CAN(Action.LIST, Resource.SERVICE_REQUESTS)}><IncidentManagement /></RouteGuard>}>
              <Route index element={getIncidentManagementPath()?.navigate}/>
              <Route path="incidents/:data?" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.INCIDENTS)}><MyIncidentViewerContainer /></RouteGuard>} />
              <Route path="serviceRequests/:data?" element={<RouteGuard canAccess={CAN(Action.LIST, Resource.SERVICE_REQUESTS)}><CloseTicketViewer /></RouteGuard>} />
            </Route>
            <Route path="/incident-management/incidentDetail/:requestId/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.INCIDENTS)}><IncidentDetail /></RouteGuard>} />
            <Route path='/invoices' element={<RouteGuard canAccess={CAN(Action.LIST, Resource.FINCAINVOICE)}><FincaInvoices /></RouteGuard>} />
            <Route path="/incident-management/serviceRequestDetail/:requestId/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.SERVICE_REQUESTS)}><ServiceRequestDetail /></RouteGuard>} />
            <Route path="/user-management/OnboardingDetail/:requestId/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_APPROVAL)}><OnboardingDetail /></RouteGuard>} />
            <Route path="/user-management/OnboardingRequestDetail/:requestId/:data?" element={<RouteGuard canAccess={CAN(Action.GET, Resource.CUSTOMER_ONBOARDING_REQUEST)}><OnboardingRequestDetail /></RouteGuard>} />
            {/* <Route path="/accountAccessRequest/:requestId" element={<AccountAccessRequestDetail />} />
            <Route path="/accountAccessApproval/:requestId" element={<AccountAccessApprovalDetail />} /> */}
            <Route path="/AccessApprovalDetail/:requestId"  element={<AccessApprovalDetail />} />
            <Route path="/broadcast" element={<RouteGuard canAccess={CAN(Action.LISTALL, Resource.BROADCAST_NOTIFICATIONS)}><Broadcast/></RouteGuard>}/>
            <Route path="/regulatory" element={<RouteGuard canAccess={CAN(Action.GET, Resource.REGULATORY)}><RegulatoryViewer/></RouteGuard>}/>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          {(((myRights && myRights?.status == "active" && emailVerified && isValidMFAUser && hasMFAEnabled) || (myRights && myRights?.status == "active" && !hasMFAEnabled && !isValidMFAUser && emailVerified)) && isActive) ? <Footer isInternal={myRights?.userType == USER_TYPE.INTERNAL}/> : <></>}
          {
            isAlertPopupOpen && (<Alert
              image={props.message.image}
              message={props.message.message}
              messageTimeout={props.message?.messageTimeout ? props.message.messageTimeout : 8000}
              isFormOpen={props.message.isFormOpen ? props.message.isFormOpen : null}
              onClose={props.closeAlertPopup}
              isAlertPopupOpen={isAlertPopupOpen}
            />
            )}
        </div>
      </AuthGuard>
    </BrowserRouter>

  );
}

const mapStateToProps = (state) => {
      return {
    myRights: state.myRights.myRights,
    myRightsLoading: state.myRights.loading,
    userStatus: state.myRights.userStatus,
    message: state.alert.alertDetails,
    isAlertPopupOpen: state.alert.isAlertPopupOpen,
    isUserLoggedIn: state.myRights.isLoggedIn,
    alertMessage: state.alertErrorMessage.alertMessage,
    alertHeader:state.alertErrorMessage.alertHeader,
    isCustomAlertOpen:state.alertErrorMessage.isCustomAlertOpen,
    isCustomErrorOpen:state.customErrorPopu.isCustomErrorOpen,
    ErrorMessage: state.customErrorPopu.errorMessage,
    ErrorHeader:state.customErrorPopu.errorHeader,
    isnote:state.customErrorPopu.errorMessage.isnote,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getRights: (userDetails) => {
      return dispatch(getMyRights(userDetails))
    },
    updateRights: (userDetails) => {
      return dispatch(updateMyRights(userDetails))
    },
    closeAlertPopup: () => {
      return dispatch(closeAlertPopup())
    },
    updateIsLoggedIn: (isLoggedIn) => {
      return dispatch(updateIsLoggedIn(isLoggedIn))
    },
    showAlertPopup: (alertHeader,alertmessage) => {
      return dispatch(showAlertPopup(alertHeader,alertmessage))
    },
    clearAlertPopup: () => {
      return dispatch(clearAlertPopup())
    },
    showErrorPopup: (message) => {
      return dispatch(showErrorPopup(message))
    },
    clearErrorPopup: () => {
      return dispatch(clearErrorPopup())
    },
    logoutUser: () => {
      return dispatch(logoutUser());
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);